import type { McpUiStyles } from "@modelcontextprotocol/ext-apps";

/** Dark World-like tokens passed to the View via official hostContext. */
export const HOST_STYLE_VARIABLES = {
  "--color-background-primary": "#101218",
  "--color-background-secondary": "#1c1c1e",
  "--color-background-tertiary": "#2c2c2e",
  "--color-text-primary": "#f5f5f7",
  "--color-text-secondary": "#8e8e93",
  "--color-text-danger": "#ff453a",
  "--color-text-success": "#30d158",
  "--color-border-primary": "#2c2c2e",
  "--font-sans":
    '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", system-ui, sans-serif',
  "--font-mono": "ui-monospace, SFMono-Regular, Menlo, Monaco, monospace",
  "--border-radius-md": "14px",
} as unknown as McpUiStyles;
